module.exports = __webpack_public_path__ + "media/images/game/categories/zabava-ec669628a344306e7f7250cdfa7247e1.png";